module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step2-2-bb47080bd61cc855a029ffcaf61e7026.gif";